import React, { useContext, useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Badge,
  InputBase,
  Button,
  Avatar
} from "@material-ui/core";
import Help from "@material-ui/icons/Help";
import SearchIcon from "@material-ui/icons/Search";
import ArrowDropDown from "@material-ui/icons/ArrowDropDown";
import logo from "../../assets/images/logo.png";
import MenuIcon from "@material-ui/icons/Menu";
import LangSelect from "./LangSelect";
import useStyles from "../../styles/commonStyle";
import { useTranslation } from "../../langs/useTranslation";
import { SubmitBtnContext } from "../../App";
import ResetPasswordForm from "../../containers/ResetPasswordForm";
import UserMenu from "./AppBarUserMenu";
import NotificationIconBtn from "./AppBarNotificationIconBtn";
import * as localforage from "localforage";
import { qaUrl } from "../../config/optionsOnAppBar";
import { releaseVersion } from "../../config/releaseVersion";
import CompanySelector from "../CompanyTree/Selector";

import { useGlobalState, useGlobalDispatch } from "../../GlobalProvider";

import _ from "lodash";

export const ModalContext = React.createContext();
const Appbar = () => {
  const classes = useStyles();
  const location = useLocation();
  const { t } = useTranslation("common");
  const [anchorEl, setAnchorEl] = useState(null); // User menu pop out position
  const [modalOpen, setModalOpen] = useState(false);
  const [username, setUsername] = useState("");
  const [avatar, setUserAvatar] = useState("");
  const { dispatch } = useContext(SubmitBtnContext);
  const isUserMenuOpen = Boolean(anchorEl);
  const [fixedOpen, setFixedOpen] = useState(true);
  const globalDispatch = useGlobalDispatch();
  const [selectedCompanyId, setSelectedCompanyId] = useState();

  const handleCompanySelect = (companyId, info) => {
    setSelectedCompanyId(companyId[0]);
    globalDispatch.setCurrentCompany(companyId[0], info.node.name);
  };

  const handleProfileMenuOpen = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleUserMenuClose = () => {
    setAnchorEl(null);
  };

  const handleResetPwdModalOpen = () => {
    setModalOpen(true);
    setAnchorEl(null);
  };

  const handleResetPwdModalClose = () => {
    setModalOpen(false);
    dispatch({ type: "stopLoading" });
  };

  const getUserInfo = async () => {
    const user = await localforage.getItem("user");
    if (user) {
      setUsername(user.name);
      setUserAvatar(user.avatar_link);
    }
  };

  const handleDrawerToggle = () => {
    setFixedOpen(!fixedOpen);
    globalDispatch.setLeftMenuStatus(fixedOpen);
  };

  useEffect(() => {
    getUserInfo();
  }, []);

  const noMunuBarPath = [
    "/",
    "/account-center",
    "/devices-groups",
    "/company-device"
  ];
  return (
    <ModalContext.Provider
      value={{ setAnchorEl, modalOpen, handleResetPwdModalClose }}
    >
      <div className={classes.grow}>
        <AppBar position="fixed" color="inherit" overlap="rectangular">
          <Toolbar>
            {_.indexOf(noMunuBarPath, location.pathname) === -1 && (
              <IconButton
                aria-label="open drawer"
                onClick={handleDrawerToggle}
                edge="start"
                className={classes.menuButton}
              >
                <MenuIcon />
              </IconButton>
            )}
            <div className={classes.title}>
              <NavLink to="/">
                {/*<img src={logo} alt="logo" className={classes.logo} />*/}
                <Typography variant="caption" color="secondary">
                  Platform
                </Typography>
                <Typography
                  variant="caption"
                  className={classes.releaseVersionText}
                >
                  {releaseVersion}
                </Typography>
              </NavLink>
            </div>
            <div className={classes.rightSection}>
              {/*<CompanySelector*/}
              {/*  companyId={selectedCompanyId}*/}
              {/*  onSelect={handleCompanySelect}*/}
              {/*  isAppBar={true}*/}
              {/*/>*/}
              <div className={classes.search}>
                <div className={classes.searchIcon}>
                  <SearchIcon />
                </div>
                <InputBase
                  placeholder={t("appbar.searchFieldText")}
                  classes={{
                    root: classes.inputRoot,
                    input: classes.inputInput
                  }}
                  inputProps={{ "aria-label": "search" }}
                />
              </div>
              <LangSelect />
              {/*<a*/}
              {/*  href={qaUrl}*/}
              {/*  target="_blank"*/}
              {/*  rel="noreferrer"*/}
              {/*  className={classes.qaLink}*/}
              {/*>*/}
              {/*  <IconButton aria-label="Q&A" color="inherit">*/}
              {/*    <Badge color="error" overlap="rectangular">*/}
              {/*      <Help />*/}
              {/*    </Badge>*/}
              {/*  </IconButton>*/}
              {/*</a>*/}
              <NotificationIconBtn />
              <Button
                edge="end"
                aria-label="User"
                aria-haspopup="true"
                onClick={handleProfileMenuOpen}
                color="inherit"
                className={classes.ueserBtn}
              >
                {avatar ? (
                  <Avatar
                    src={avatar}
                    alt={username}
                    className={classes.avatar}
                  />
                ) : (
                  <Avatar className={classes.avatar}>
                    {username.charAt(0).toUpperCase()}
                  </Avatar>
                )}
                <Typography variant="caption" className={classes.usernameText}>
                  {username}
                </Typography>
                <ArrowDropDown />
              </Button>
            </div>
          </Toolbar>
        </AppBar>
        <UserMenu
          open={isUserMenuOpen}
          onClose={handleUserMenuClose}
          anchorEl={anchorEl}
          handleResetPwdModelOpen={handleResetPwdModalOpen}
        />
        <ResetPasswordForm open={modalOpen} close={handleResetPwdModalClose} />
      </div>
    </ModalContext.Provider>
  );
};

export default Appbar;
